export const initialRoleState = {
  roles: [],
  role: null,
  status: 'idle',
  error: null, // ✅ Changed to null instead of an object
};
